export const defaultLocale = 'en-us';
